import styled from "styled-components";

import { Row } from "components/common";

const Container = styled(Row)`
  font-size: 14px;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: -0.04px;
  padding: 8px 12px;
  border-radius: 6px;
  & > svg {
    color: #3C535C;
  }
  &:hover {
    cursor: pointer;
    background-color: rgba(9, 119, 158, 0.07);
  }
`;

const VerticalDivider = styled.div`
  width: 1px;
  background-color: #555;
  height: 30px;
  margin: 0px 8px;
`;

export { Container, VerticalDivider };
